import { checkauth } from '../Helper';

// Utenti > Task: viste del progetto, scheda issue (pagina, non modale), impostazioni e notifiche
const TasksBoard = () => import('../views/tasks/Board.vue');
const TasksBacklog = () => import('../views/tasks/Backlog.vue');
const TasksTimeline = () => import('../views/tasks/Timeline.vue');
const TasksCalendar = () => import('../views/tasks/Calendar.vue');
const TasksList = () => import('../views/tasks/List.vue');
const TasksIssue = () => import('../views/tasks/Issue.vue');
const TasksSettings = () => import('../views/tasks/Settings.vue');
const TasksNotifications = () => import('../views/tasks/Notifications.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	// il backlog è la vista di partenza della sezione, la board viene subito dopo
	{ path: '/tasks', name: 'tasks-backlog', component: TasksBacklog, beforeEnter: auth },
	{ path: '/tasks/board', name: 'tasks-board', component: TasksBoard, beforeEnter: auth },
	// vecchio indirizzo del backlog: resta valido per link e preferiti già salvati
	{ path: '/tasks/backlog', redirect: '/tasks' },
	{ path: '/tasks/timeline', name: 'tasks-timeline', component: TasksTimeline, beforeEnter: auth },
	{ path: '/tasks/calendar', name: 'tasks-calendar', component: TasksCalendar, beforeEnter: auth },
	{ path: '/tasks/list', name: 'tasks-list', component: TasksList, beforeEnter: auth },
	{ path: '/tasks/new', name: 'tasks-new', component: TasksIssue, beforeEnter: auth },
	{ path: '/tasks/settings', name: 'tasks-settings', component: TasksSettings, beforeEnter: auth },
	{ path: '/tasks/notifications', name: 'tasks-notifications', component: TasksNotifications, beforeEnter: auth },
	// chiave della issue (AZ-12): le parole fisse sopra non ci finiscono mai
	{ path: '/tasks/:key([A-Za-z][A-Za-z0-9]{1,9}-\\d+)', name: 'tasks-issue', component: TasksIssue, beforeEnter: auth },
];
